import { FirebaseDocument } from "common/models/FirebaseDocument";
import i18n from "i18n";

import {
  WBSRows,
  WBSResource,
  WBSTasks,
  TaskRows,
  Location,
} from "modules/WBS/models";
import { EContentType, ERowType } from "common/enums";
import { v4 as uuidv4 } from "uuid";

class Service {
  wbsResources(doc?) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new WBSResource(
          data.code,
          data.description,
          data.unitCost,
          data.unit,
          data.origin,
          data.disabled,
          data.category,
          ...(doc.ref && [doc.ref])
        );
        return new FirebaseDocument<WBSResource>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<WBSResource>(doc.id, WBSResource.getDefault());
  }

  wbsTasks(doc) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new WBSTasks(
          data.code,
          data.description,
          data.unitCost,
          data.unit,
          data.origin,
          data.disabled,
          data.childrenCount,
          ...(doc.ref && [doc.ref])
        );
        return new FirebaseDocument<WBSTasks>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<WBSTasks>(doc.id, WBSTasks.getDefault());
  }

  wbsRows(doc) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new WBSRows(
          data.rowType,
          data.rowIndex,
          data.description,
          data.total,
          data.parentStage,
          data.parentTask,
          data.contentId,
          data.quantity,
          data.unit,
          data.unitCost,
          data.contentType,
          data.rowCode,
          data.formula,
          data.rateLibraryId,
          data.rateLibraryName,
          data.rateLibraryCode,
          data.fromModelMap,
          data.takeOffQuantity,
          data.modelMapFull,
          data.modelMapDescription,
          data.customProperties,
          data.vendaBdi,
          data.totalBdi,
          data.bdi,
          data.hasCoefficient,
          data.coefficient
        );
        return new FirebaseDocument<WBSRows>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<WBSRows>(doc.id, WBSRows.getDefault());
  }

  taskRows(doc) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new TaskRows(
          data.type,
          data.index,
          data.quantity,
          data.total,
          data.disabled,
          data.convertedTotalCost,
          data.contentReference
        );
        return new FirebaseDocument<TaskRows>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<TaskRows>(doc.id, TaskRows.getDefault());
  }

  locations(doc) {
    if (doc.data) {
      let data = doc.data();
      if (data) {
        let docModel = new Location(data.id, data.parent, data.path);
        return new FirebaseDocument<Location>(doc.id, docModel);
      }
    }
    return new FirebaseDocument<Location>(doc.id, Location.getDefault());
  }

  getDefaultActivity = ({
    code,
    description,
    origin,
    unitCost,
    totalBdi,
    vendaBdi,
    unit,
    class: category,
  }: any) => ({
    code: code ? code : "",
    description: description ? description : i18n.project.table.newResource,
    origin: origin ? origin : "WBS",
    unitCost: unitCost ? unitCost : 0,
    totalBdi: totalBdi ? totalBdi : 0,
    vendaBdi: vendaBdi ? vendaBdi : 0,
    unit: unit ? unit : "UN",
    category: category ? category : "other",
  });

  getNewUUID() {
    return uuidv4().replace(/-/g, "");
  }

  getDefaultRow = ({
    rowType,
    rowIndex,
    description = i18n.project.table.newResource,
    total = 0,
    contentId,
    quantity = 1,
    unit = "UN",
    unitCost = 0,
    totalBdi = 0,
    vendaBdi = 0,
    contentType = EContentType.OTHER,
    customProperties,
  }: any) =>
    rowType === ERowType.STAGE
      ? customProperties
        ? {
            rowType,
            rowIndex,
            description,
            total,
            totalBdi,
            customProperties,
          }
        : {
            rowType,
            rowIndex,
            description,
            total,
            totalBdi,
          }
      : ({
          rowType,
          rowIndex,
          description: description,
          total,
          contentId: contentId ? contentId : this.getNewUUID(),
          quantity: quantity,
          unit,
          unitCost,
          totalBdi,
          vendaBdi,
          contentType,
        } as any);

  getDefaultTaskRow = ({
    contentReference,
    description,
    disabled,
    index,
    quantity,
    total,
    type,
  }: any) => ({
    contentReference: contentReference
      ? contentReference
      : { id: "", parent: "", path: "" },
    description: description ? description : "default row",
    disabled: disabled ? disabled : "",
    index: index ? index : 0,
    quantity: quantity ? quantity : 1,
    total: total ? total : 0,
    type: type ? type : "wbsResources",
  });
}

let WBSModels = new Service();

export { WBSModels };



// WEBPACK FOOTER //
// ./src/modules/WBS/WBSModels.tsx